export default __webpack_public_path__ + "trash-1220d2b41f2019611fec43dc5a41aeb7.svg";